import { AxiosResponse } from "axios";
import API from "../api";

import { Product } from "../models/shipments";
import BaseService from "./_base.service";

const endpoint = "products";

const ProductService = {
  ...BaseService<Product>({ endpoint }),
  async getAllV2(options?: any): Promise<AxiosResponse<Product[]>> {
    return await API.get(`/${endpoint}/v2`, { params: options });
  },
  async countV2(options?: any): Promise<AxiosResponse<number>> {
    return await API.get(`/${endpoint}/v2/count`, { params: options });
  },
  async update(id: number, data: any): Promise<AxiosResponse<any>> {
    return await API.put(`/${endpoint}/${id}`, data);
  },
  async create(data: any): Promise<AxiosResponse<any>> {
    return await API.post(`/${endpoint}`, data);
  },
  async getStock(reportType: string, options?: any): Promise<AxiosResponse<any>> {
    return await API.get(`/${endpoint}/stock`, { params: options });
  },
  async getStockOnHand(reportType: string, options?: any): Promise<AxiosResponse<any>> {
    return await API.get(`/${endpoint}/stock-on-hand`, { params: options });
  },
};

export default ProductService;
